import styled from "styled-components";

export const Container = styled.div.attrs({})`
  min-width: 467px;
  width: 100%;
  height: fit-content;
  min-height: 361px;
  display: flex;
  flex-direction: column;

  background-color: white;
  border-radius: 12px;

  padding: 21px 0;
`;

export const Header = styled.div.attrs({})`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
  padding: 0 27px;

  position: relative;
`;

export const Title = styled.p.attrs({})`
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.theme.palette.colors.text};

  margin: 0;
`;

export const TotalSum = styled.p.attrs({})`
  font-size: 18px;
  font-weight: 500;
  color: black;

  margin: 0;
  position: absolute;
  right: 27px;
`;

export const ToggleContainer = styled.div.attrs({})`
  width: 147px;
  min-width: fit-content;
  height: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-right: 27px;
  margin-top: 27px;
  align-self: end;

  background-color: ${(props) => props.theme.palette.colors.lightprimary};

  border-radius: 8px;
`;

export const Button = styled.div.attrs({})`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  color: ${(props) => props.theme.palette.colors.text};


  ${(props) => props.active && `
    background-color: ${props.theme.palette.colors.blue};
    color: white;
  `}

  border-radius: 8px;
`;

export const ButtonText = styled.p.attrs({})`
  font-size: 10px;
  font-weight: 500;
  
  margin: 0;
`;